import { Component, Inject, OnInit } from "@angular/core";
import { DomSanitizer, SafeResourceUrl } from "@angular/platform-browser";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";

@Component({
    selector: "app-guide",
    templateUrl: "./guide.component.html",
    styleUrls: ["./guide.component.scss"],
    standalone: false
})
export class GuideComponent implements OnInit {
  public pdfToShow: SafeResourceUrl = null!;

  constructor(
    private sanitizer: DomSanitizer,
    private dialogRef: MatDialogRef<GuideComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { pdfPath: string },
  ) {}

  ngOnInit(): void {
    const rawPath = this.data.pdfPath;
    const encodedPath = encodeURI(rawPath);
    this.pdfToShow = this.sanitizer.bypassSecurityTrustResourceUrl(encodedPath);
  }

  closeDialog() {
    this.dialogRef.close();
  }
}
